import { render } from "./section-treasury.vue?vue&type=template&id=7fc529f8&scoped=true"
import script from "./section-treasury.vue?vue&type=script&lang=js"
export * from "./section-treasury.vue?vue&type=script&lang=js"

import "./section-treasury.vue?vue&type=style&index=0&id=7fc529f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc529f8"]])

export default __exports__